import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Products from '../components/Products';
import SupportBlock from '../components/SupportBlock';
import Stats from '../components/Stats';
import Testimonials from '../components/Testimonials';
import FreeSupport from '../components/FreeSupport';
import FAQ from '../components/FAQ';
import CTABanner from '../components/CTABanner';
import Footer from '../components/Footer';

export default function HomePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Products />
        <SupportBlock />
        <Stats />
        <Testimonials />
        <FreeSupport />
        <FAQ />
        <CTABanner />
      </main>
      <Footer />
    </>
  );
}
